// Internal Imports (Models & Services)
import { Deficiency } from '@/api/models/Contracts';
import { ContractDetailService } from '@/api/services/contractDetailService';

// External Imports (Redux & Redux-Saga)
import { takeLatest, call, put, CallEffect, PutEffect } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';

// Redux Slice Actions
import {
  fetchDeficiencyRequest,
  fetchDeficiencySuccess,
  fetchDeficiencyFailure,
} from './deficiencySlice';
//import { EquipmentRequest } from "@/api/models/BaseRequest";
//import { PayloadAction } from "@reduxjs/toolkit";

/**
 * Saga function to fetch equipment data.
 * It makes an API call and dispatches either a success or failure action.
 */
function* fetchDeficiencySaga(): Generator<
  CallEffect<Deficiency[]> | PutEffect,
  void,
  Deficiency[]
> {
  try {
    const deficiency: Deficiency[] = yield call(ContractDetailService.fetchDeficiency);

    yield put(fetchDeficiencySuccess(deficiency));
  } catch (error: unknown) {
    const errorMessage = error instanceof Error ? error.message : 'Fetching equipments failed';
    yield put(fetchDeficiencyFailure(errorMessage));
  }
}

/**
 * Watcher Saga that listens for `fetchEquipmentRequest` actions
 * and triggers `fetchEquipmentSaga` when the action is dispatched.
 */
export function* watchDeficiency(): SagaIterator {
  yield takeLatest(fetchDeficiencyRequest.type, fetchDeficiencySaga);
}
